import { Component, Input, OnInit, EventEmitter, Output } from "@angular/core";
import { PracticeService } from "../../../core/services/v2/practice.service";
import { PractitionerFavoriteRes } from "../../../core/model/v2/practitioner/practitionerFavoritesList";
import { PhysicianOptionService } from "../../shared/physician-option/physician-option.service";

@Component({
  selector: "app-sidebar-physician-favorites",
  templateUrl: "./sidebar-physician-favorites.component.html",
  styleUrls: ["./sidebar-physician-favorites.component.scss"],
})
export class SidebarPhysicianFavoritesComponent implements OnInit {
  @Input() sectionName: string;
  @Output() toggleEvent = new EventEmitter();

  practId: number;
  loader: boolean = false;
  showHideSelected = false;

  physicianSearchName: string = "";
  physicianSearchZip: string = "";
  selected = false;

  dataSource: PractitionerFavoriteRes[];
  displayedColumns: string[] = ["physicianName"];

  role: string;
  selectedFavPractitioner: PractitionerFavoriteRes;

  searchResultsRecords: number = 20;
  constructor(
    private practiceService: PracticeService,
    private physicianOptionService: PhysicianOptionService
  ) {}

  ngOnDestroy() {}

  ngOnInit() {}

  addFavorite(practFav: PractitionerFavoriteRes) {
    this.selectedFavPractitioner = practFav;
    const physicianFav = {
      practitionerId: this.physicianOptionService.getPhysician().id,
      favoriteId: this.selectedFavPractitioner.practitionerId,
      favoriteNpi: this.selectedFavPractitioner.practitionerNPI,
      favoritesTypeId: 1,
    };
    this.practiceService.addPractitionerFavorites(physicianFav).subscribe(
      (_) => {
        this.toggleEvent.emit(practFav);
        this.showHideSelected = true;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  searchPhysician() {
    if (!this.physicianSearchName || this.physicianSearchName == "") {
      this.dataSource = null;
      this.loader = false;
      return;
    }

    const self = this;
    self.loader = true;

    this.practiceService
      .getPractitionersByName(this.physicianSearchName, this.physicianSearchZip)
      .subscribe(
        (res) => {
          if (res["response"]["isSuccess"]) {
            if (res.practitioners.length > 0) {
              self.dataSource = res.practitioners.slice(
                0,
                this.searchResultsRecords
              );
            } else {
              this.dataSource = null;
            }
          }
        },
        (error) => {
          console.error(error);
          self.loader = false;
        },
        () => {
          self.loader = false;
        }
      );
  }

  cancel() {
    this.showHideSelected = true;
    this.toggleEvent.emit();
  }
}
